module.exports = "/src/views/player/help/images/ar2.jpg";